/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { Sidebar } from '@components/ui/Sidebar';
import { Stack, StackProps, styled } from '@mui/material';
import { FC } from 'react';

import { PagesHeightWithEnvBanner, SidebarWidth } from '@/lib/constants/theme';

const StyledPageLayout = styled('div', {
  name: 'Page',
  slot: 'Layout',
})({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
});

type PageLayoutProps = StackProps;

const PageLayout: FC<PageLayoutProps> = ({ children }) => {
  return (
    <StyledPageLayout>
      <Stack component="nav" direction="column" flexGrow={0}>
        <Sidebar />
      </Stack>

      <Stack
        component="main"
        flexGrow={1}
        minWidth={0}
        sx={{
          marginLeft: SidebarWidth,
          bgcolor: (theme) => theme.palette.background.paper,
          minHeight: PagesHeightWithEnvBanner,
        }}
      >
        {children}
      </Stack>
    </StyledPageLayout>
  );
};

export default PageLayout;
